import { VStack } from '@montel/montelpro-shared-components-v2';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const StyledTopMenuItem = styled(NavLink)<{
	$isActive: boolean;
}>`
	display: flex;
	flex-grow: 0;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0;
	position: static;
	text-decoration: none;
	color: inherit;
	font-weight: 600;
	position: relative;

	${({ $isActive, theme }) => {
		const { typography, spacing, colors, borderRadii } = theme;

		return css`
			color: ${$isActive ? colors.textDefault : colors.textSubtle};
			font-size: ${typography.size.sm};
			gap: ${spacing.xs};
			cursor: ${$isActive ? 'default' : 'pointer'};
			pointer-events: ${$isActive ? 'none' : 'default'};

			&:focus-visible {
				outline: 2px solid ${colors.bgWarning};
				border-radius: ${borderRadii.base};
				outline-offset: 2px;
			}

			svg {
				width: ${typography.size.lg};
				height: ${typography.size.lg};
			}

			&:hover {
				color: ${colors.textDefault};
			}
		`;
	}}
`;

export const StyledVStack = styled(VStack)`
	position: relative;
`;

export const StyledUnderline = styled.div<{ $active: boolean }>`
	position: absolute;
	bottom: -6px;
	height: 2px;

	${({ theme, $active }) => css`
		background-color: ${theme.colors.bgBrand};
		width: ${$active ? '100%' : '0%'};
	`}
`;

export const StyledListItem = styled.li`
	position: relative;
	list-style-type: none;
	width: max-content;
`;
